import React from 'react';

export type TextVariant =
  | 'largeTitle'
  | 'title2'
  | 'title3'
  | 'body'
  | 'bodySecondary'
  | 'subHeadline'
  | 'caption1'
  | 'caption2';

type TextProps = {
  variant?: TextVariant;
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
};

const typography = {
  LargeTitle: {
    Semibold: {
      fontFamily: "'W95FA', Tahoma, sans-serif",
      fontSize: '32px',
      fontWeight: 600,
      lineHeight: 1.5,
    },
  },
  Title200: {
    Semibold: {
      fontFamily: "'W95FA', Tahoma, sans-serif",
      fontSize: '24px',
      fontWeight: 600,
      lineHeight: 1.5,
    },
  },
  Title300: {
    SemiBold: {
      fontFamily: "'W95FA', Tahoma, sans-serif",
      fontSize: '20px',
      fontWeight: 600,
      lineHeight: 1.5,
    },
  },
  TextBody: {
    Regular: {
      fontFamily: "'W95FA', Tahoma, sans-serif",
      fontSize: '18px',
      fontWeight: 400,
      lineHeight: 1.5,
    },
    Secondary: {
      fontFamily: "'W95FA', Tahoma, sans-serif",
      fontSize: '18px',
      fontWeight: 400,
      color: '#37353E',
      lineHeight: 1.5,
    },
  },
  TextSubheadline: {
    Regular: {
      fontFamily: "'W95FA', Tahoma, sans-serif",
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: 1.5,
    },
  },
  TextCaption100: {
    Regular: {
      fontFamily: "'W95FA', Tahoma, sans-serif",
      fontSize: '12px',
      fontWeight: 400,
      lineHeight: 1.5,
    },
  },
  TextCaption200: {
    Regular: {
      fontFamily: "'W95FA', Tahoma, sans-serif",
      fontSize: '11px',
      fontWeight: 400,
      lineHeight: 1.5,
    },
  },
};

const Text: React.FC<TextProps> = ({
  variant = 'body',
  children,
  className,
  style,
  ...rest
}) => {
  const styleMap: Record<TextVariant, React.CSSProperties> = {
    largeTitle: typography.LargeTitle.Semibold,
    title2: typography.Title200.Semibold,
    title3: typography.Title300.SemiBold,
    body: typography.TextBody.Regular,
    bodySecondary: typography.TextBody.Secondary,
    subHeadline: typography.TextSubheadline.Regular,
    caption1: typography.TextCaption100.Regular,
    caption2: typography.TextCaption200.Regular,
  };

  return (
    <span
      className={className}
      style={{ ...styleMap[variant], ...style }}
      {...rest}
    >
      {children}
    </span>
  );
};

export { Text };
